import { Card as RadixCard, Box } from '@radix-ui/themes';
import clsx from 'clsx';
import { ReactNode } from 'react';

type Props = {
  header?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
};

export const Card = ({
  header,
  content,
  footer,
  className,
  headerClassName,
  contentClassName,
  footerClassName,
}: Props) => {
  return (
    <RadixCard
      className={clsx(
        'flex flex-col rounded-2xl border border-gray-600 bg-dark-default py-5 px-4',
        className
      )}
    >
      {header && <Box className={clsx('mb-[34px]', headerClassName)}>{header}</Box>}
      {content && <Box className={clsx('mb-[18px]', contentClassName)}>{content}</Box>}
      {footer && <Box className={footerClassName}>{footer}</Box>}
    </RadixCard>
  );
};

export default Card;
